export const isEmpty = (value: unknown): boolean => {
  if (value == null) return true
  if (value === '') return true
  if (Array.isArray(value)) return value.length === 0
  return false
}

export const valuesEqual = (a: unknown, b: unknown): boolean => {
  if (a === b) return true
  if (Array.isArray(a) && Array.isArray(b)) {
    return a.length === b.length && a.every((v, i) => valuesEqual(v, b[i]))
  }
  if (a == null || b == null) return false
  // URL-parsed values are strings; compare loosely against typed defaults
  // (e.g. URL `limit=50` vs default number 50, or `'true'` vs boolean true).
  return String(a) === String(b)
}

export const isActive = (value: unknown, defaultValue: unknown): boolean => {
  if (isEmpty(value) && isEmpty(defaultValue)) return false
  if (valuesEqual(value, defaultValue)) return false
  return !isEmpty(value)
}

/**
 * Builds the patch passed to `onChange` when "Clear all" is clicked.
 * Keys with a default reset to that default; keys without a default become
 * `null` so they are dropped from the query string.
 */
export const buildClearPatch = (
  keys: ReadonlyArray<string>,
  defaults: Record<string, unknown> | undefined,
): Record<string, unknown> =>
  Object.fromEntries(keys.map((key) => [key, defaults?.[key] ?? null]))
